import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import {
  isGettingTrackedWebsites,
  trackedWebsites,
  getSelectedWebsiteGuid
} from "../../store/tracked_websites/selectors";
import { getTrackedWebsites, changeSelectedWebsite } from "../../store/tracked_websites/operations";
import DashboardSettingsLayout from "../../components/DashboardSettings/DashboardSettingsLayout";

class DashboardSettings extends Component {
  constructor(props) {
    super(props);

    this.handleTrackedWebsiteChange = this.handleTrackedWebsiteChange.bind(this);
  }

  componentDidMount() {
    this.props.getTrackedWebsites();
  }

  handleTrackedWebsiteChange(websiteGuid) {
    this.props.changeSelectedWebsite(websiteGuid);
  }
  render() {
    return (
      <DashboardSettingsLayout
        push={this.props.push}
        isLoading={this.props.isFetchingTrackedWebsites}
        trackedWebsites={this.props.trackedWebsites}
        selectedWebsite={this.props.selectedWebsite}
        handleTrackedWebsiteChange={key => this.handleTrackedWebsiteChange(key)}
        selectedOption={this.props.selectedOption}
      />
    );
  }
}

const mapStateToProps = state => ({
  isFetchingTrackedWebsites: isGettingTrackedWebsites(state),
  trackedWebsites: trackedWebsites(state),
  selectedWebsite: getSelectedWebsiteGuid(state)
});

export default connect(mapStateToProps, { getTrackedWebsites, changeSelectedWebsite, push })(DashboardSettings);
